export default {"src":"/_next/static/media/instagram-light.13de393e.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};